export default {
  label: {
    open: 'Apertura',
    waiting: 'En espera',
    answer: 'Respuesta',
    finished: 'Finalización',
  },
  date: {
    month: 'mes',
    day: 'día',
    hour: 'hora',
    minute: 'minuto',
    second: 'segundo',
    default: '0 días 0 horas',
  },
};
